import { lazy } from "react";

export { VACANCY_PATH } from "./vacancy-path";
export const VacancyPage = lazy(() => import("./vacancy"));
export { ToVacancy } from "./to-vacancy";
